export default {
  'HELP_PAGE_CONTENT': 'Help Center Page',
  'BACK_TO_ALERTS': 'Back to alerts',
  'ALERT_TABLE_HEAD_ALERT': 'Alert',
  'ALERT_TABLE_HEAD_START_TIME': 'Start date & time',
  'ALERT_TABLE_CELL_ALERT': '{event_type} at {intersection_name}',
  'ALERT_TABLE_CELL_START_TIME': '{start_time}',
  'ALERT_TABLE_CELL_OPEN_ON_MAP': 'Open on map',
  'BUSINESS_RULES_ROUTES_TAB': 'Routes',
  'BUSINESS_RULES_PRIORITY_RULES_TAB': 'Priority Rules',
  'BUSINESS_RULES_ROUTES_TABLE_HEAD_LAST_SAVED': 'Last saved',
  'BUSINESS_RULES_ROUTES_TABLE_HEAD_STATUS': 'Status',
  'BUSINESS_RULES_ROUTES_TABLE_CELL_EDIT_RULES': 'Edit rules',
  'BUSINESS_RULES_ROUTES_SEARCH_PLACEHOLDER': 'Search routes',
  'USERS_AND_PERMISSIONS_USERS_TAB': 'Users',
  'USERS_AND_PERMISSIONS_ROLES_TAB': 'Roles',
  'USERS_AND_PERMISSIONS_REQUESTS_TAB': 'Requests',
  'USERS_AND_PERMISSIONS_USERS_TABLE_TITLE': 'Manage or invite users',
  'INVITE_NEW_USER': 'Invite new user',
  'U_AND_P_TABLE_HEADER_EMAIL': 'Email',
  'U_AND_P_TABLE_HEADER_REGISTER_DATE': 'Register Date',
  'U_AND_P_TABLE_HEADER_ROLE': 'Role',
  'U_AND_P_TABLE_HEADER_APPROVED_AGENCIES': 'Approved Agencies',
  'U_AND_P_ADD_AGENCY': 'Add agency',
  'U_AND_P_NO_ADDITIONAL_CHOICES': 'No Additional Choices',
  'MULTI_SELECT_PLACEHOLDER': 'Select items',
  'LOGOUT': 'Logout',
  'SELECT_INTERSECTION': 'Select intersection',
  'BACK_TO_WEBSITE': 'Back to website',
  'PAGE_NOT_FOUND': 'Page not found',
  'PAGE_NOT_FOUND_DESCRIPTION': 'The page you were looking for could not be found',
  'MAP_SEARCH': 'Search for an agency',
  'LIVE_MAP.EVP_SEARCH_PLACEHOLDER': 'Find a vehicle, event, or intersection.',
  'LIVE_MAP.TRANSIT_SEARCH_PLACEHOLDER_LYT21': 'Find a bus or intersection',
  'LIVE_MAP.TRANSIT_SEARCH_PLACEHOLDER': 'Search a bus or intersection',
  'ROUTES_NAV_TSP_STATISTICS': 'TSP Statistics',
  'ROUTES_NAV_PERFORMANCE': 'Performance',
  'SYSTEM_HEALTH_SIGNAL_NETWORK_TAB': 'Signal Network',
  'SYSTEM_HEALTH_TRANSIT_VEHICLE_TAB': 'Transit Vehicle CAD/AVL',
  'SYSTEM_HEALTH_TSP_HEALTH_TAB': 'TSP Health',
  'SYSTEM_HEALTH_ALERTS_TAB': 'Alerts',
  'SYSTEM_HEALTH_METRICS_GROUP': 'Health metrics',
  'SYSTEM_HEALTH_OPERATIONS_GROUP': 'Operational awareness',
  'TEAM_ACTIVE_USERS_TAB': 'Active Users',
  'TEAM_USER_LOGIN_HISTORY_TAB': 'User Login History',
  'TEAM_REQUESTS_TAB': 'Requests',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.TITLE': 'Average TSP Calls Per Hour',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.CSV_Y': 'Average TSP Calls per Hour',
  'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.CSV_HOUR': 'Hour',
  'TEAM.MODAL.EDIT_ROLE.AGENCY_OWNER_USE_TRANSFER_OWNERSHIP': 'To assign agency ownership, use the Transfer Ownership action on the current Agency Owner row.',
};
